import React from 'react';
import { Table } from 'semantic-ui-react';

// Components
// @ts-ignore
import TableHeadTableCell from 'components/TableHeadTableCell';
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER
} from 'components/RoleGate/constants';
import RoleGate from 'components/RoleGate';

// @ts-ignore
import HourlyRateEntryExistsGate from '../HourlyRateEntryExistsGate';
// @ts-ignore
import PieceRateEntryExistsGate from '../PieceRateEntryExistsGate';
// @ts-ignore
import TimesheetTimesheetEntriesTableHeadCheckbox from './components/TimesheetTimesheetEntriesTableHeadCheckbox';

const TimesheetTimesheetEntriesTableHead = (): React.ReactElement => {
    return (
        <Table.Header
            className="sticky"
            // HACK inline styles
            style={{
                fontSize: 14
            }}
        >
            <Table.Row>
                <RoleGate requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}>
                    <React.Fragment>
                        <Table.HeaderCell
                            textAlign="center"
                            verticalAlign="middle"
                            className="events-table-cell-padding"
                            // HACK inline styles
                            style={{
                                lineHeight: 0,
                                borderRadius: 0
                            }}
                        >
                            <TimesheetTimesheetEntriesTableHeadCheckbox />
                        </Table.HeaderCell>
                        <Table.HeaderCell />
                    </React.Fragment>
                </RoleGate>
                <TableHeadTableCell
                    label="Date"
                    value="date"
                    defaultSort="date_ascending"
                />
                <TableHeadTableCell
                    label="Full Name"
                    value="person.fullName"
                    defaultSort="date_ascending"
                />
                <TableHeadTableCell
                    label="Task"
                    value="workType.name"
                    defaultSort="date_ascending"
                />
                <TableHeadTableCell
                    label="Area"
                    value="entity.pathNames"
                    defaultSort="date_ascending"
                />
                <TableHeadTableCell
                    label="Start Time"
                    value="startTime"
                    defaultSort="date_ascending"
                />
                <TableHeadTableCell
                    label="End Time"
                    value="endTime"
                    defaultSort="date_ascending"
                />
                <TableHeadTableCell
                    label="Lun. Brk"
                    value="unpaidBreakMinutes"
                    defaultSort="date_ascending"
                />
                <HourlyRateEntryExistsGate>
                    <TableHeadTableCell
                        label="Hours"
                        value="totalPaidHours"
                        defaultSort="date_ascending"
                    />
                </HourlyRateEntryExistsGate>
                <TableHeadTableCell
                    label="Count"
                    value="units"
                    defaultSort="date_ascending"
                />
                <PieceRateEntryExistsGate>
                    <TableHeadTableCell
                        label="Rate"
                        value="rate"
                        defaultSort="date_ascending"
                    />
                    <TableHeadTableCell
                        label="Pd.Brk"
                        value="paidBreakMinutes"
                        defaultSort="date_ascending"
                    />
                    <TableHeadTableCell
                        label="Hours"
                        value="totalPieceRateHours"
                        defaultSort="date_ascending"
                    />
                    <TableHeadTableCell
                        label="Earnings"
                        value="earnings"
                        defaultSort="date_ascending"
                    />
                    <TableHeadTableCell
                        label="Achieved"
                        value="effectiveRate"
                        defaultSort="date_ascending"
                    />
                    <TableHeadTableCell
                        label="Pd.Brk"
                        value="paidBreakDollars"
                        defaultSort="date_ascending"
                    />
                </PieceRateEntryExistsGate>
                <Table.HeaderCell
                    style={{
                        borderRadius: 0
                    }}
                />
            </Table.Row>
        </Table.Header>
    );
};

export default TimesheetTimesheetEntriesTableHead;
